import { configureStore, combineReducers } from "@reduxjs/toolkit";

import dashboardReducer from "../views/Dashboard/dashboardSlice";
import searchReducer from "../views/SearchBox/searchSlice";
import reportReducer from "../views/Report/reportSlice";
import usersReducer from "../views/Users/usersSlice";
import labelsReducer from "../views/Users/labelsSlice";

const appReducer = combineReducers({
  dashboard: dashboardReducer,
  search: searchReducer,
  report: reportReducer,
  users: usersReducer,
  labels: labelsReducer
});

const rootReducer = (state, action) => {
  // If the action is the logout action, reset the state.
  if (action.type === 'user/logout') {
    // Return the result of calling the appReducer with an initial state (undefined).
    // This forces combineReducers to return the initial state for all slices.
    return appReducer(undefined, action);
  }
  // Otherwise, return the normal state after processing the action.
  return appReducer(state, action);
};

export default configureStore({
  reducer: rootReducer
});
